import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import svgTickGreen from '@img/icons/tick-green.svg';
import Button from '@stories/Components/Buttons/Button/Button';
import styled from 'styled-components';
const ItemList = styled.div `
  ${setCssVar('accentColor', brand.hta.green)};
  ${setCssVar('bgColor', brand.hta.green)};
  ${setCssVar('bgColorAlt', brand.hta.greenLight)};
  ${setCssVar('fgColor', brand.white)};

  .theme-hh & {
    ${setCssVar('accentColor', brand.hortHouse.green)};
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('bgColor', brand.hortHouse.green)};
    ${setCssVar('bgColorAlt', brand.hortHouse.greenLight)};
  }

  .theme-apl & {
    ${setCssVar('accentColor', brand.apl.green)};
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('bgColor', brand.apl.greenAlt)};
    ${setCssVar('bgColorAlt', brand.apl.greenLight)};
  }

  .theme-rss & {
    ${setCssVar('accentColor', brand.rss.green)};
    ${setCssVar('fgColor', brand.white)};
    ${setCssVar('bgColor', brand.greyVeryLight)};
    ${setCssVar('bgColorAlt', brand.rss.greenLight)};
  }

  display: flex;
  flex-direction: column;
  min-height: 100%;
`;
const Title = styled.button `
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  ${fonts.sourceSansPro.semiBold};
  font-size: 18px;
  line-height: 24px;
  padding: 12px 24px;
  margin-bottom: 12px;

  .theme-rss & {
    color: ${cssVar('fgColor')};
  }

  > svg {
    display: block;
    height: 16px;
    margin-right: 12px;
    width: 16px;
  }
`;
const Item = styled.button `
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  ${fonts.sourceSansPro.regular};
  font-size: 18px;
  line-height: 24px;
  padding: 12px 24px;

  .theme-rss & {
    color: ${cssVar('fgColor')};
  }

  &[data-selected='true'] {
    ${fonts.sourceSansPro.semiBold};
  }

  &[data-postcode='true'] {
    position: relative;
    z-index: 1;
    flex-direction: column;
    width: 100%;
  }

  span > span {
    width: 25px;
    height: 25px;
    ${fonts.sourceSansPro.regular};
    font-size: 14px;
    border-radius: 50%;
    background-color: ${brand.apl.green};
    color: ${brand.white};
    margin-left: 10px;
  }
`;
const Arrow = styled.span `
  display: block;
  color: ${brand.black};
  height: 16px;
  margin-left: auto;
  width: 16px;

  .theme-rss & {
    color: ${cssVar('fgColor')};
  }
`;
const Tick = styled.span `
  display: block;
  color: ${brand.hta.green};
  height: 11px;
  margin-left: auto;
  width: 16px;

  .theme-rss & {
    color: ${cssVar('accentColor')};
  }
`;
const Clear = styled.button `
  display: block;
  background: none;
  border: 0;
  ${fonts.sourceSansPro.semiBold};
  font-size: 18px;
  line-height: 24px;
  margin: auto 0 0;
  padding: 12px 24px;

  .theme-rss & {
    color: ${cssVar('fgColor')};
  }
`;
const CheckboxArea = styled.div `
  padding: 12px 24px;
`;
const CheckboxAreaLabel = styled.p `
  ${fonts.sourceSansPro.semiBold};
  font-size: 18px;
  line-height: 34px;
`;
const RadioArea = styled.div `
  padding: 12px 24px;

  > div {
    margin: 0 0 24px !important;
  }

  label > span {
    padding: 0 40px 0 0;

    &::before {
      display: none;
    }

    &::after {
      background: transparent url('${svgTickGreen}') no-repeat center;
      right: 0;
      left: auto;
      top: 0;
      padding: 0;
      height: 26px;
    }
  }

  input:checked + span {
    font-weight: bold;
  }
`;
const ApplyFilters = styled(Button) `
  background-color: ${brand.hta.green};
  border-color: ${brand.hta.green};

  .theme-apl & {
    background-color: ${brand.apl.green};
    border-color: ${brand.apl.green};
  }

  .theme-hh & {
    background-color: ${brand.hortHouse.green};
    border-color: ${brand.hortHouse.green};
  }

  &:hover {
    background-color: ${cssVar('bgColorAlt')};
    border-color: ${cssVar('bgColorAlt')};
  }
  span {
    color: ${brand.black};
  }
`;
const RemoveFilters = styled(Button) `
  margin-top: 15px;
  border-color: ${brand.black};

  span {
    color: ${brand.black};
  }

  &:hover {
    background-color: ${cssVar('bgColorAlt')};
    border-color: ${cssVar('bgColorAlt')};
  }

  .theme-rss & {
    border-color: ${brand.white};

    span {
      color: ${brand.white};
    }

    &:hover {
      border-color: ${cssVar('bgColorAlt')};

      span {
        color: ${brand.black};
      }
    }
  }
`;
const BtnHolder = styled.div ``;
const FilterBtns = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1 0 auto;
  padding: 30px;
`;
const AdditionalFilterBtn = styled.button `
  padding: 4px 8px;
`;
const PostcodeSearchButton = styled.button `
  ${ButtonReset}
  display: flex;
  align-items: center;
  border: 1px solid ${cssVar('fgColor')};
  border-radius: 9px;
  color: ${cssVar('fgColor')};
  height: 48px;
  width: 100%;
  position: relative;
  ${fonts.sourceSansPro.regular};
  padding: 0 30px 0 12px;
  font-size: 16px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;

  @media ${from(Device.Desktop)} {
    font-size: 20px;
    line-height: 24px;
  }

  strong {
    ${fonts.sourceSansPro.semiBold};
    margin-right: 4px;
  }

  svg {
    width: 17px;
    color: ${brand.apl.green};
    margin-right: 8px;
  }
`;
const ClearFilter = styled.span `
  display: flex;
  margin: 6px auto -30px;
  width: fit-content;

  button {
    padding: 3px 6px;
    border: 0;
    text-transform: capitalize;

    &:first-of-type {
      background-color: ${brand.greyLight};
    }

    &:last-of-type {
      background-color: ${brand.grey};
      color: ${brand.white};
    }
  }
`;
export default {
    ApplyFilters,
    Arrow,
    BtnHolder,
    CheckboxArea,
    CheckboxAreaLabel,
    RadioArea,
    Clear,
    FilterBtns,
    Item,
    ItemList,
    RemoveFilters,
    Tick,
    Title,
    AdditionalFilterBtn,
    PostcodeSearchButton,
    ClearFilter,
};
